webpackJsonp([213534597649335],{

/***/ 150:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AHS.d9e0ce70.png";

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Amnesty.3181d19d.png";

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/BMUN.0087b4aa.png";

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DPS.3baabd3d.png";

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SIP.0c018e96.png";

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/UCBMUN.6c5376db.png";

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/background.3ed9261d.png";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/blog.ab98ebf7.png";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/case_competition.9138378b.png";

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(344);
	
	var _OrganizationPhotoGroup = __webpack_require__(68);
	
	var _OrganizationPhotoGroup2 = _interopRequireDefault(_OrganizationPhotoGroup);
	
	var _IRCActivity = __webpack_require__(199);
	
	var _IRCActivity2 = _interopRequireDefault(_IRCActivity);
	
	var _background = __webpack_require__(459);
	
	var _background2 = _interopRequireDefault(_background);
	
	var _case_competition = __webpack_require__(461);
	
	var _case_competition2 = _interopRequireDefault(_case_competition);
	
	var _blog = __webpack_require__(460);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	var _journal = __webpack_require__(462);
	
	var _journal2 = _interopRequireDefault(_journal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomePage = function HomePage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'TitleScreen' },
	      _react2.default.createElement('img', { className: 'Background', src: _background2.default, alt: 'background' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'Title' },
	        'The International Relations Council of Berkeley'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Subtitle' },
	        'Facilitating dialogue on global issues between on-campus student organizations.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'OrgsScreen' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Title', style: { zIndex: 2 } },
	        'Founded in 2016 by six UC Berkeley student organizations:'
	      ),
	      _react2.default.createElement(_OrganizationPhotoGroup2.default, null),
	      _react2.default.createElement('div', { className: 'SlantOne' }),
	      _react2.default.createElement('div', { className: 'SlantTwo' }),
	      _react2.default.createElement('div', { className: 'SlantThree' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'InfoScreen' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Title' },
	        'What We Do'
	      ),
	      _react2.default.createElement(_IRCActivity2.default, {
	        name: 'IRC Case Competition',
	        description: 'We invite teams of Berkeley students to develop innovative solutions to the most pressing problems in international relations and developmental politics.',
	        img: _case_competition2.default,
	        link: '/case-competitions'
	      }),
	      _react2.default.createElement(_IRCActivity2.default, {
	        name: 'IRC Blog',
	        description: 'The Global Citizen is a student-run blog about all things international relations, updated bi-monthly. We\'re looking for new contributors!',
	        img: _blog2.default,
	        link: 'https://medium.com/@ircofberkeley',
	        external: true
	      }),
	      _react2.default.createElement(_IRCActivity2.default, {
	        name: 'IRC Journal',
	        description: 'The International Relations Review of Berkeley is published semesterly. This semester\'s theme is "International Law and Disorder".',
	        img: _journal2.default,
	        link: '/irc-journal'
	
	      })
	    )
	  );
	};
	
	exports.default = HomePage;
	module.exports = exports['default'];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(145);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(345);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IRCActivity = function IRCActivity(props) {
	  var ActivityLink = function ActivityLink() {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.link },
	      'More Info'
	    );
	  };
	  if (props.external) {
	    ActivityLink = function ActivityLink() {
	      return _react2.default.createElement(
	        'a',
	        { href: props.link },
	        'More Info'
	      );
	    };
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'IRCActivity' },
	    _react2.default.createElement('img', { className: 'ActivityLogo', alt: '', src: props.img }),
	    _react2.default.createElement(
	      'div',
	      { className: 'ActivityTitle' },
	      props.name
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'ActivityDescription' },
	      props.description
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'ActivityButton' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ButtonTitle2' },
	        _react2.default.createElement(ActivityLink, null)
	      )
	    )
	  );
	};
	
	exports.default = IRCActivity;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganizationPhoto = function OrganizationPhoto(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'OrganizationPhoto' },
	    _react2.default.createElement('img', { className: 'OrgImage', alt: '', src: props.img }),
	    _react2.default.createElement(
	      'div',
	      { className: 'OrgHover' },
	      _react2.default.createElement(
	        'div',
	        { className: 'HoverTitle' },
	        props.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'HoverDescription' },
	        props.description
	      ),
	      _react2.default.createElement('div', { className: 'HoverMedia' })
	    )
	  );
	};
	
	exports.default = OrganizationPhoto;
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(42);
	
	__webpack_require__(92);
	
	var _OrganizationPhoto = __webpack_require__(67);
	
	var _OrganizationPhoto2 = _interopRequireDefault(_OrganizationPhoto);
	
	var _BMUN = __webpack_require__(114);
	
	var _BMUN2 = _interopRequireDefault(_BMUN);
	
	var _UCBMUN = __webpack_require__(117);
	
	var _UCBMUN2 = _interopRequireDefault(_UCBMUN);
	
	var _SIP = __webpack_require__(116);
	
	var _SIP2 = _interopRequireDefault(_SIP);
	
	var _DPS = __webpack_require__(115);
	
	var _DPS2 = _interopRequireDefault(_DPS);
	
	var _Amnesty = __webpack_require__(113);
	
	var _Amnesty2 = _interopRequireDefault(_Amnesty);
	
	var _AHS = __webpack_require__(112);
	
	var _AHS2 = _interopRequireDefault(_AHS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganizationPhotoGroup = function OrganizationPhotoGroup() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'PhotoWrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'OrganizationPhotoGroup' },
	      _react2.default.createElement(_OrganizationPhoto2.default, {
	        name: 'AHS',
	        description: 'Non-partisan debate organization that inspires and educates students in the importance of American leadership in the world',
	        img: _AHS2.default
	      }),
	      _react2.default.createElement(_OrganizationPhoto2.default, {
	        name: 'BMUN',
	        description: 'Berkeley Model United Nations is a student-run organization on the UC Berkeley campus the runs the world\'s premier -- and very first -- United Nations simulation.',
	        img: _BMUN2.default
	      }),
	      _react2.default.createElement(_OrganizationPhoto2.default, {
	        name: 'UCBMUN',
	        description: 'University of California, Berkeley\'s competitive Model United Nations team. In addition to its top ranked travel team, UCBMUN hosts the west coast\'s oldest running intercollegiate conference every year in spring in San Francisco, CA.',
	        img: _UCBMUN2.default
	      }),
	      _react2.default.createElement(_OrganizationPhoto2.default, {
	        name: 'SIP',
	        description: 'An honors society for international studies that promotes and rewards scholarship and service among students and faculty in higher education so as to foster creative performance and integrity in the conduct of world affairs.',
	        img: _SIP2.default
	      }),
	      _react2.default.createElement(_OrganizationPhoto2.default, {
	        name: 'Delta Phi Epsilon',
	        description: 'UC Berkeley\u2019s only co-ed professional Foreign Service and international relations fraternity.',
	        img: _DPS2.default
	      }),
	      _react2.default.createElement(_OrganizationPhoto2.default, {
	        name: 'Amnesty International',
	        description: 'Amnesty International undertakes research and action focused on preventing and ending grave abuses of the rights to physical and mental integrity, freedom of conscience and expression, and freedom from discrimination, within the context of its work to promote all human rights.',
	        img: _Amnesty2.default
	      })
	    )
	  );
	};
	
	exports.default = OrganizationPhotoGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HomePage = __webpack_require__(198);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_HomePage2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-a94a843226a35d940ad6.js